import {
  ListAndSearchAllAccountsTypeEnum,
  useListAndSearchAllAccounts,
} from "@bn/api/apiv1";
import { useMyself } from "@api";

const FREE_PORTFOLIO_LIMIT = 2;

export const usePortfolioLimit = () => {
  const { data: myself, isPending: isMyselfPending } = useMyself();
  const { data, isPending: isAccountsPending } = useListAndSearchAllAccounts({
    type: [ListAndSearchAllAccountsTypeEnum._01_DEPOT],
  });

  const isLoading = isMyselfPending || isAccountsPending;
  const portfolioCount = data?.accounts?.length ?? 0;

  return {
    isLoading,
    isPortfolioLimitReached:
      !isLoading &&
      !!myself?.isUserFree &&
      portfolioCount >= FREE_PORTFOLIO_LIMIT,
  };
};
